import { transformToLink } from '../../Link/LinkTransformers';
import { PrismicTable, Table } from './Table';

export const transformToTable = (
    prismicTable: PrismicTable,
): Table => ({
    csvUrl: transformToLink(prismicTable.table_data),
});
